<template>
  <div class="table-search">
    <div
      class="table-search-item"
      v-for="(searchItem, searchIndex) in searchList"
      :key="searchIndex"
      >
      <component :is="'search-'+searchItem.type" :propKey="searchItem.prop" 
        :isAsync="searchItem.isAsync" :asyncItems="searchItem.asyncItems" :asyncOptions="searchItem.asyncOptions" 
        :items="searchItem.items" v-model="searchForm[searchItem.prop]" @search="search" :attrs="searchItem.attrs" :isShopsSearch="searchItem.isShopsSearch"/> 
    </div>
     <div class="table-search-item">
      <el-date-picker
        v-model="operateTime"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        :picker-options="pickerOptions"
        :clearable="false"
      />
     </div>
    <div class="table-search-item"><el-button @click="search" style="height:100%" type="primary">查询</el-button></div>
    <div class="table-search-item"><el-button @click="clear" style="height:100%">清空</el-button></div>
    <slot></slot>
  </div>
</template>

<script>
import SearchSelect from "@/components/prod/center/components/SearchSelect.vue";
import SearchInput from "@/components/prod/center/components/SearchInput.vue";
import prod_center_dictionary from "@/components/prod/center/dictionary";
import {getDateStart, getDateEnd, pickerOptions} from "@/pages/supplier/prod/log/util";
import { mapGetters } from 'vuex';
import { getStaffList } from '@servers/base/user/index.js';

export default {
  components: {
    SearchSelect,
    SearchInput,
  },
  data() {
    return {
      pickerOptions,
      searchForm: {
        subCode: '',
        shopName: '',
        supplierName: '',
        outerId: '',
        startTime: '',
        endTime: ''
      },
      staffAsyncItems: [],
      operateTime: [
        getDateStart(),
        getDateEnd(),
      ],
    }
  },
  computed: {
    ...mapGetters(["supplierNameList", "routerPrefix", "getSubCode", "supplierNameMap"]),
    shops() {
      return this.$store.getters.shops_all
    },
    query() {
      const _query = {}
      this.searchForm = {
        ...this.searchForm,
        startTime: this.operateTime[0],
        endTime: this.operateTime[1]
      }
      for (const key in this.searchForm) {
        if (this.searchForm[key] !== '') {
          _query[key] = this.searchForm[key]
          if (key === 'shopName' && _query[key]) {
            const val = this.shops.find(item => item.userId === _query[key])
            _query[key] = val ? (val.shortTitle || val.title) : ''
          }
          if (key === 'supplierName') {
            _query[key] = this.supplierNameMap[this.searchForm[key]]
          }
        }
      }
      return _query
    },
    searchList() {
      const searchList_all = [
        { prop: 'subCode', type: 'select', attrs: { placeholder: '途径' }, items: this.getSubCode },
        { prop: 'status', type: 'select', attrs: { placeholder: '状态' }, items: prod_center_dictionary.NEW_PRODUCT_STATUS },
        { prop: 'shopName', type: 'select', attrs: { placeholder: '店铺', multiple: false }, items: this.shops, isShopsSearch: true },
        this.routerPrefix === 's_' ? null : { prop: 'supplierName', type: 'select', attrs: { placeholder: '请选择供销商', filterable: true }, items: this.supplierNameList },
        { prop: 'outerId', type: 'input', attrs: { placeholder: '款式编码' } },
        { prop: 'staffIds', type: 'select', attrs: { placeholder: '操作人', multiple: true }, isAsync: true, asyncItems: this.staffAsyncItems, asyncOptions: { queryFn: this.getStaffIds } },
      ]
      return searchList_all.filter(Boolean)
    }
  },
  watch: {
    $route: {
      handler(to) {
        const { query } = to
        if (to.name === `${this.routerPrefix}prod_log`) {
          if (query.startTime) {
            this.$set(this.operateTime, 0, query.startTime)
          }
          if (query.endTime) {
            this.$set(this.operateTime, 1, query.endTime)
          }
        }
      },
      deep: true,
      immediate: true,
    },
    operateTime(newVal) {
      if (newVal == null) {
        this.operateTime = [getDateStart(), getDateEnd()]
      }
    }
  },
  mounted() {
    this.getStaffIds()
  },
  methods: {
    async getStaffIds(_params) {
      if (_params) {
        _params.queryStaffName = _params?.queryText || ''
      }
      const res = await getStaffList(_params)
      if (res) {
        this.staffAsyncItems = (res.list || []).map(item => ({
          ...item,
          label: item.accountName,
          value: item.accountId,
        }))
      }
    },
    method_getSearchForm() {
      return this.query
    },
    search() {
      this.$emit('search', this.query)
    },
    clear() {
      this.operateTime = [getDateStart(), getDateEnd()]
      this.searchForm = {
        subCode: '',
        shopName: '',
        supplierName: '',
        outerId: '',
        startTime: '',
        endTime: ''
      }
      this.search()
    },
  }
}
</script>

<style lang="scss" scoped>
.table-search {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;

  &-item {
    margin-right: 8px;
    margin-bottom: 8px;
  }

}
</style>
